var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.9718 16.0052L6.50709 15.6069C5.86643 15.0704 0.272461 10.2393 0.272461 6.70539C0.272461 3.00545 3.27187 0.00604248 6.9718 0.00604248C10.6717 0.00604248 13.6711 3.00545 13.6711 6.70539C13.6711 10.2393 8.07718 15.0705 7.43918 15.6095L6.9718 16.0052ZM6.9718 1.45464C4.07327 1.45792 1.72437 3.80682 1.72109 6.70536C1.72109 8.92542 5.16271 12.4719 6.9718 14.0951C8.78093 12.4713 12.2225 8.92273 12.2225 6.70536C12.2192 3.80682 9.87037 1.45795 6.9718 1.45464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.97197 9.36065C5.50534 9.36065 4.31641 8.17172 4.31641 6.70509C4.31641 5.23847 5.50534 4.04953 6.97197 4.04953C8.43859 4.04953 9.62753 5.23847 9.62753 6.70509C9.62753 8.17172 8.43862 9.36065 6.97197 9.36065ZM6.97197 5.37728C6.23866 5.37728 5.64419 5.97175 5.64419 6.70506C5.64419 7.43837 6.23866 8.03284 6.97197 8.03284C7.70528 8.03284 8.29975 7.43837 8.29975 6.70506C8.29975 5.97175 7.70531 5.37728 6.97197 5.37728Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.82023c0f154938ed6d60c2d891b4cf17.svg";
export { ForwardRef as ReactComponent };